import React, { Component } from 'react';

import mapLayerApi from "../../apiV2/mapLayerApi";

import KMLLayer from './layers/KMLLayer';
import GroupLayer from './layers/GroupLayer';
import { GeoJSONLayer } from "./index";

export default class ProxyLayers extends Component {

    state = {
        mapLayers: [],
        noAutoShow: []
    };

    componentDidMount() {
        let attrs = {};
        if (this.props.layers && this.props.layers.length > 0) {
            attrs.layers = this.props.layers;
        }
        if (this.props.publicOnly) {
            attrs.publicOnly = true;
        }
        mapLayerApi.getLayers(attrs).then((response) => {
            this.setState({
                mapLayers: response
            });
        });
        this.setState({
            noAutoShow: this.props.noAutoShow ? this.props.noAutoShow : []
        });
    }

    getPopupTemplate = (layerCode) => {
        switch (layerCode) {
            case 'hoolpiir':
                return {
                    title: "{name}"
                };
            default:
                return {};
        }
    };

    render() {
        let layers = this.state.mapLayers.map((layer) => {
            let url = layer.url ? layer.url : window.origin.replace(/:\d+$/, '') + '/proxy/layer/' + layer.code + '/';
            if (layer.type === 'arcgis') {
                return (<GroupLayer key={'gl_' + layer.id}
                    map={this.props.map}
                    urlMapServer={url}
                    visible={(this.state.noAutoShow && this.state.noAutoShow.length > 0 && this.state.noAutoShow.includes(layer.code)) ? false : true}
                    layers={layer.layers}
                    opacity={parseInt(layer.opacity) / 100}
                    title={layer.name}
                    id={'gl_' + layer.id}
                />)
            } else if (layer.type === 'kml') {
                return (<KMLLayer key={'gl_' + layer.id}
                    map={this.props.map}
                    url={url}
                    visible={(this.state.noAutoShow && this.state.noAutoShow.length > 0 && this.state.noAutoShow.includes(layer.code)) ? false : true}
                    opacity={parseInt(layer.opacity) / 100}
                    title={layer.name}
                    id={'gl_' + layer.id}
                />);
            } else if (layer.type === 'local') {
                return (<GeoJSONLayer
                    map={this.props.map}
                    id={'gl_' + layer.code}
                    key={layer.id}
                    visible={layer.code !== 'hoolpiir'}
                    opacity={parseInt(layer.opacity) / 100}
                    url={process.env.REACT_APP_API_V2 + 'map/layers/' + layer.code + '/' + layer.id + '.geojson'}
                    popupTemplate={this.getPopupTemplate(layer.code)}
                    title={layer.name}
                />);
            } else {
                console.error(`Layer type "${layer.type}" is not supported!`);
                return null;
            }
        });

        layers = layers.filter((l) => l !== null);

        return (
            <>
                {layers}
            </>
        );
    }
}
